enum HoldReleaseReason {
  SICK = 'SICK',
  EMERGENCY = 'EMERGENCY',
  DOUBLE_BOOKED = 'DOUBLE_BOOKED',
  OTHER = 'OTHER',
}

enum ProviderScheduleBlockState {
  HELD = 'HELD',
  RELEASED = 'RELEASED',
}

enum ProviderScheduleEntryKind {
  APPOINTMENT = 'APPOINTMENT',
  BLOCK = 'BLOCK',
}

export { HoldReleaseReason, ProviderScheduleBlockState, ProviderScheduleEntryKind }
